import { render, staticRenderFns } from "./SystemNeo.vue?vue&type=template&id=0e2728ce&scoped=true&"
import script from "./SystemNeo.vue?vue&type=script&lang=ts&"
export * from "./SystemNeo.vue?vue&type=script&lang=ts&"
import style0 from "./SystemNeo.vue?vue&type=style&index=0&id=0e2728ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2728ce",
  null
  
)

export default component.exports